// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/location_types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp.js";

export const protobufPackage = "photon.imessage.v1";

/**
 * Source / freshness of a friend's location, mirroring Apple's
 * `FMFLocationType`:
 *
 *   LEGACY   stored last-known fix from Find My's cache
 *   LIVE     real-time fix from an active sharing session
 *   SHALLOW  approximate fix from a low-power background source
 */
export enum FriendLocationType {
  FRIEND_LOCATION_TYPE_UNSPECIFIED = 0,
  FRIEND_LOCATION_TYPE_LEGACY = 1,
  FRIEND_LOCATION_TYPE_LIVE = 2,
  FRIEND_LOCATION_TYPE_SHALLOW = 3,
  UNRECOGNIZED = -1,
}

export function friendLocationTypeFromJSON(object: any): FriendLocationType {
  switch (object) {
    case 0:
    case "FRIEND_LOCATION_TYPE_UNSPECIFIED":
      return FriendLocationType.FRIEND_LOCATION_TYPE_UNSPECIFIED;
    case 1:
    case "FRIEND_LOCATION_TYPE_LEGACY":
      return FriendLocationType.FRIEND_LOCATION_TYPE_LEGACY;
    case 2:
    case "FRIEND_LOCATION_TYPE_LIVE":
      return FriendLocationType.FRIEND_LOCATION_TYPE_LIVE;
    case 3:
    case "FRIEND_LOCATION_TYPE_SHALLOW":
      return FriendLocationType.FRIEND_LOCATION_TYPE_SHALLOW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FriendLocationType.UNRECOGNIZED;
  }
}

export function friendLocationTypeToJSON(object: FriendLocationType): string {
  switch (object) {
    case FriendLocationType.FRIEND_LOCATION_TYPE_UNSPECIFIED:
      return "FRIEND_LOCATION_TYPE_UNSPECIFIED";
    case FriendLocationType.FRIEND_LOCATION_TYPE_LEGACY:
      return "FRIEND_LOCATION_TYPE_LEGACY";
    case FriendLocationType.FRIEND_LOCATION_TYPE_LIVE:
      return "FRIEND_LOCATION_TYPE_LIVE";
    case FriendLocationType.FRIEND_LOCATION_TYPE_SHALLOW:
      return "FRIEND_LOCATION_TYPE_SHALLOW";
    case FriendLocationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * A single currently shared friend location. Coordinates are absent while the
 * device is acquiring a fix (`is_locating_in_progress = true`).
 */
export interface SharedFriendLocation {
  /**
   * Canonical handle (E.164 phone or full email). Primary key for
   * client-side correlation.
   */
  address: string;
  name?: string | undefined;
  latitude?: number | undefined;
  longitude?:
    | number
    | undefined;
  /** Horizontal accuracy in meters. */
  accuracy?:
    | number
    | undefined;
  /** Fully formatted reverse-geocoded address (e.g. street + city + region). */
  longAddress?:
    | string
    | undefined;
  /** Compact reverse-geocoded label (e.g. neighborhood or city only). */
  shortAddress?: string | undefined;
  isLocatingInProgress: boolean;
  locationType: FriendLocationType;
  locationTimestamp?: Date | undefined;
  expiresAt?: Date | undefined;
}

/** Single live update pushed by `Watch*` streams. */
export interface SharedFriendLocationUpdated {
  /**
   * Monotonic per-process sequence for this transient live feed. Gaps mean
   * the subscriber missed frames within the session; replay is not available.
   */
  sourceSequence: number;
  location: SharedFriendLocation | undefined;
}

function createBaseSharedFriendLocation(): SharedFriendLocation {
  return {
    address: "",
    name: undefined,
    latitude: undefined,
    longitude: undefined,
    accuracy: undefined,
    longAddress: undefined,
    shortAddress: undefined,
    isLocatingInProgress: false,
    locationType: 0,
    locationTimestamp: undefined,
    expiresAt: undefined,
  };
}

export const SharedFriendLocation: MessageFns<SharedFriendLocation> = {
  encode(message: SharedFriendLocation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.latitude !== undefined) {
      writer.uint32(25).double(message.latitude);
    }
    if (message.longitude !== undefined) {
      writer.uint32(33).double(message.longitude);
    }
    if (message.accuracy !== undefined) {
      writer.uint32(41).double(message.accuracy);
    }
    if (message.longAddress !== undefined) {
      writer.uint32(50).string(message.longAddress);
    }
    if (message.shortAddress !== undefined) {
      writer.uint32(58).string(message.shortAddress);
    }
    if (message.isLocatingInProgress !== false) {
      writer.uint32(64).bool(message.isLocatingInProgress);
    }
    if (message.locationType !== 0) {
      writer.uint32(72).int32(message.locationType);
    }
    if (message.locationTimestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.locationTimestamp), writer.uint32(82).fork()).join();
    }
    if (message.expiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expiresAt), writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SharedFriendLocation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSharedFriendLocation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.accuracy = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.longAddress = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.shortAddress = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isLocatingInProgress = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.locationType = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.locationTimestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.expiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SharedFriendLocation {
    return {
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : undefined,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : undefined,
      accuracy: isSet(object.accuracy) ? globalThis.Number(object.accuracy) : undefined,
      longAddress: isSet(object.longAddress)
        ? globalThis.String(object.longAddress)
        : isSet(object.long_address)
        ? globalThis.String(object.long_address)
        : undefined,
      shortAddress: isSet(object.shortAddress)
        ? globalThis.String(object.shortAddress)
        : isSet(object.short_address)
        ? globalThis.String(object.short_address)
        : undefined,
      isLocatingInProgress: isSet(object.isLocatingInProgress)
        ? globalThis.Boolean(object.isLocatingInProgress)
        : isSet(object.is_locating_in_progress)
        ? globalThis.Boolean(object.is_locating_in_progress)
        : false,
      locationType: isSet(object.locationType)
        ? friendLocationTypeFromJSON(object.locationType)
        : isSet(object.location_type)
        ? friendLocationTypeFromJSON(object.location_type)
        : 0,
      locationTimestamp: isSet(object.locationTimestamp)
        ? fromJsonTimestamp(object.locationTimestamp)
        : isSet(object.location_timestamp)
        ? fromJsonTimestamp(object.location_timestamp)
        : undefined,
      expiresAt: isSet(object.expiresAt)
        ? fromJsonTimestamp(object.expiresAt)
        : isSet(object.expires_at)
        ? fromJsonTimestamp(object.expires_at)
        : undefined,
    };
  },

  toJSON(message: SharedFriendLocation): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.latitude !== undefined) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== undefined) {
      obj.longitude = message.longitude;
    }
    if (message.accuracy !== undefined) {
      obj.accuracy = message.accuracy;
    }
    if (message.longAddress !== undefined) {
      obj.longAddress = message.longAddress;
    }
    if (message.shortAddress !== undefined) {
      obj.shortAddress = message.shortAddress;
    }
    if (message.isLocatingInProgress !== false) {
      obj.isLocatingInProgress = message.isLocatingInProgress;
    }
    if (message.locationType !== 0) {
      obj.locationType = friendLocationTypeToJSON(message.locationType);
    }
    if (message.locationTimestamp !== undefined) {
      obj.locationTimestamp = message.locationTimestamp.toISOString();
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<SharedFriendLocation>): SharedFriendLocation {
    return SharedFriendLocation.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SharedFriendLocation>): SharedFriendLocation {
    const message = createBaseSharedFriendLocation();
    message.address = object.address ?? "";
    message.name = object.name ?? undefined;
    message.latitude = object.latitude ?? undefined;
    message.longitude = object.longitude ?? undefined;
    message.accuracy = object.accuracy ?? undefined;
    message.longAddress = object.longAddress ?? undefined;
    message.shortAddress = object.shortAddress ?? undefined;
    message.isLocatingInProgress = object.isLocatingInProgress ?? false;
    message.locationType = object.locationType ?? 0;
    message.locationTimestamp = object.locationTimestamp ?? undefined;
    message.expiresAt = object.expiresAt ?? undefined;
    return message;
  },
};

function createBaseSharedFriendLocationUpdated(): SharedFriendLocationUpdated {
  return { sourceSequence: 0, location: undefined };
}

export const SharedFriendLocationUpdated: MessageFns<SharedFriendLocationUpdated> = {
  encode(message: SharedFriendLocationUpdated, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sourceSequence !== 0) {
      writer.uint32(8).uint64(message.sourceSequence);
    }
    if (message.location !== undefined) {
      SharedFriendLocation.encode(message.location, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SharedFriendLocationUpdated {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSharedFriendLocationUpdated();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sourceSequence = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.location = SharedFriendLocation.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SharedFriendLocationUpdated {
    return {
      sourceSequence: isSet(object.sourceSequence)
        ? globalThis.Number(object.sourceSequence)
        : isSet(object.source_sequence)
        ? globalThis.Number(object.source_sequence)
        : 0,
      location: isSet(object.location) ? SharedFriendLocation.fromJSON(object.location) : undefined,
    };
  },

  toJSON(message: SharedFriendLocationUpdated): unknown {
    const obj: any = {};
    if (message.sourceSequence !== 0) {
      obj.sourceSequence = Math.round(message.sourceSequence);
    }
    if (message.location !== undefined) {
      obj.location = SharedFriendLocation.toJSON(message.location);
    }
    return obj;
  },

  create(base?: DeepPartial<SharedFriendLocationUpdated>): SharedFriendLocationUpdated {
    return SharedFriendLocationUpdated.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SharedFriendLocationUpdated>): SharedFriendLocationUpdated {
    const message = createBaseSharedFriendLocationUpdated();
    message.sourceSequence = object.sourceSequence ?? 0;
    message.location = (object.location !== undefined && object.location !== null)
      ? SharedFriendLocation.fromPartial(object.location)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
